import Error from '../model/Error';
import MembershipNumber from '../dto/MembershipNumber';
import axios from 'axios';

export default class MembershipNumberRepository {
    static getNext(clubId, memberSettings) {
        let params = memberSettings ? {memberSettings: memberSettings } : {};
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/membership-number/next`, params)
                .then(response => resolve(MembershipNumber.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
